import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=34679f25&scoped=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=34679f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34679f25",
  null
  
)

export default component.exports